import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "mb-4"
};
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_3 = {
  key: 0,
  class: "font-weight-medium mb-2"
};
const _hoisted_4 = {
  class: "ml-4"
};
import { computed, reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'LlListConfirmationDialog',
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    message: {
      type: String,
      default: 'Are you sure?'
    },
    toggleText: {
      type: String,
      default: 'Cancel'
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    showWarningIcon: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: ''
    },
    // List-specific props
    listItems: {
      type: Array,
      default: () => []
    },
    listTitle: {
      type: String,
      default: ''
    },
    maxListHeight: {
      type: String,
      default: '300px'
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    _useCssVars(_ctx => ({
      "v0d0f1b90": __props.maxListHeight
    }));
    const props = __props;
    const emits = __emit;
    const state = reactive({
      isVisible: false
    });
    const textColor = computed(() => props.showWarningIcon ? 'primary' : 'error');
    let resolvePromise;
    function open() {
      state.isVisible = true;
      return new Promise(resolve => {
        resolvePromise = resolve;
      });
    }
    function close() {
      state.isVisible = false;
    }
    function confirm() {
      emits('confirm');
      close();
      resolvePromise(true);
    }
    function cancel() {
      emits('cancel');
      close();
      resolvePromise(false);
    }

    // Expose the `open` function to make it accessible from the parent
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: state.isVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.isVisible = $event),
        "max-width": "600",
        "data-cy": __props.dataCy || 'll-list-confirmation-dialog'
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.title), 1)]),
            _: 1
          }), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.showWarningIcon ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: "mr-2",
              color: "warning"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-alert", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(__props.message), 1)]), __props.listItems && __props.listItems.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.listTitle ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.listTitle), 1)) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listItems, (item, index) => {
              return _openBlock(), _createElementBlock("li", {
                key: index,
                class: "mb-1"
              }, _toDisplayString(item.title), 1);
            }), 128))])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "pa-4"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onClick: cancel
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.toggleText), 1)]),
              _: 1
            }), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              color: textColor.value,
              onClick: confirm,
              "data-cy": "confirm-button"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
              _: 1
            }, 8, ["color"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "data-cy"]);
    };
  }
};